import React from "react";
import { Formik } from "formik";
import { Form, InputGroup, Button, Container, Row, Col } from "react-bootstrap";
import { AiOutlineExclamationCircle } from "react-icons/ai";
import { useTranslation } from "react-i18next";
import {
  getEducationInputs,
  getValidationSchema,
  getHandleValidations,
} from "../formEntities/educationEntities";

const EducationForm = ({
  shake,
  handleNoEducation,
  noEducationInfo,
  handleFormikSubmit,
  initialValues,
  education,
  userData
}) => {
  const { t } = useTranslation();
  const educationInputs = getEducationInputs(t);
  const validationSchema = getValidationSchema(t);
  const handleValidatations = getHandleValidations(t);
  // Convert MM/DD/YYYY to YYYY-MM-DD for date input
  const toDateInputFormat = (dateStr) => {
    if (!dateStr || dateStr.length !== 10) return "";
    const [month, day, year] = dateStr.split("/");
    return `${year}-${month}-${day}`;
  };

  // Convert YYYY-MM-DD to MM/DD/YYYY for storage
  const toStorageFormat = (dateStr) => {
    if (!dateStr) return "";
    const [year, month, day] = dateStr.split("-");
    return `${month}/${day}/${year}`;
  };

  // Get today's date in YYYY-MM-DD format for max attribute
  const getTodayString = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const styles = {
    errorStyle: {
      border: "1px solid red",
      borderTopRightRadius: "0",
      borderBottomRightRadius: "0",
    },
    fieldErrMessage: {
      color: "red",
      paddingLeft: "5px",
    },
    errIcon: {
      fontSize: "20px",
      color: "red",
    },
    inputGroupTextStyle: {
      border: "1px solid red",
      background: "white",
    },
    errText: {
      color: "red",
    },
  };

  const handleAdd = (values) => {
    if (!values.schoolName) {
      shake();
    }
  };

  return (
    <Formik
      validationSchema={validationSchema}
      initialValues={initialValues}
      validate={(values) => handleValidatations(values)}
      onSubmit={(values, actions) => handleFormikSubmit(values, actions)}
    >
      {({ values, errors, touched, handleChange, handleSubmit, setFieldValue }) => (
        <Container className="px-0">
          {/* {console.log("Values:", values, "\nErrors:", errors)} */}
          <Form noValidate onSubmit={handleSubmit}>
            {/* Skip Step Checkbox */}
            {education.length === 0 && (
              <section className="text-start">
                <p>{t("education.gedPrompt")}</p>
                <Form.Group
                  className="skip-this-step text-start"
                  controlId="form-basic-checkbox"
                >
                  <Form.Check
                    type="checkbox"
                    label={t("education.gedCheckbox")}
                    onChange={() => handleNoEducation()}
                    checked={noEducationInfo ? true : false}
                    value={noEducationInfo}
                  />
                </Form.Group>
              </section>
            )}
            <hr />

            {/* Inputs  */}
            <section>
              <Container>
                <Row>
                  {educationInputs.map((input, index) => (
                    <Col
                      sm={12}
                      md={6}
                      key={index}
                    >
                      <>
                        <Form.Group
                          className="mb-3 text-start"
                          controlId={index}
                        >
                          <Form.Label>{input.label}</Form.Label>
                          <InputGroup>
                            {input.prependIcon && (
                              <InputGroup.Text
                                id="inputGroupPrepend"
                                style={
                                  errors[input.name] &&
                                  touched[input.name] &&
                                  styles.inputGroupTextStyle
                                }
                              >
                                @
                              </InputGroup.Text>
                            )}
                            <Form.Control
                              type={input.name === "startDate" || input.name === "endDate" ? "date" : input.type}
                              placeholder={input.name === "startDate" || input.name === "endDate" ? undefined : input.placeholder}
                              name={input.name}
                              onChange={input.name === "startDate" || input.name === "endDate"
                                ? (e) => setFieldValue(input.name, toStorageFormat(e.target.value))
                                : handleChange}
                              max={input.name === "startDate" || input.name === "endDate" ? getTodayString() : undefined}
                              maxLength={input.name === "schoolZip" ? 5 : 100}
                              value={input.name === "startDate" || input.name === "endDate"
                                ? toDateInputFormat(values[input.name])
                                : values[input.name]}
                              style={
                                errors[input.name] && touched[input.name]
                                  ? styles.errorStyle
                                  : null
                              }
                              disabled={userData.submissionDate}
                            />
                            {errors[input.name] && touched[input.name] && (
                              <InputGroup.Text
                                style={styles.inputGroupTextStyle}
                              >
                                <AiOutlineExclamationCircle
                                  style={styles.errIcon}
                                />
                              </InputGroup.Text>
                            )}
                          </InputGroup>
                          {errors[input.name] && touched[input.name] ? (
                            <div style={styles.fieldErrMessage}>
                              {errors[input.name]}
                            </div>
                          ) : null}
                        </Form.Group>
                      </>
                    </Col>
                  ))}
                </Row>
              </Container>
            </section>

            <Button type="submit" onClick={() => handleAdd(values)}>
              {t("common.add")}
            </Button>
          </Form>
        </Container>
      )}
    </Formik>
  );
};

export default EducationForm;
